import React from 'react'
import PropTypes from 'prop-types'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import RegisterForm from 'views/Forms/RegisterForm'
import translation from '../../translation/translate';

import registerPageStyle from 'assets/jss/material-dashboard-pro-react/views/registerPageStyle'

const client = process.env.REACT_APP_CLIENT

class RegisterPage extends React.Component {
  render() {
    const { classes, history } = this.props

    return (
      <div className={classes.content}>
        <div className={classes.container}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={12} md={10}>
              <Card className={classes.cardSignup}>
                <h2 className={classes.cardTitle}>{translation[client].register_title}</h2>
                <CardBody>
                  <GridContainer justify='center'>
                    <GridItem xs={12}>
                      <RegisterForm classes={classes} history={history}/>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    )
  }
}

RegisterPage.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
}

export default (withStyles(registerPageStyle)(RegisterPage))



// WEBPACK FOOTER //
// ./src/views/Pages/RegisterPage.jsx